import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    partnerLegals:[]
  },
  getters: {
    GetpartnerLegals: (state) => state.partnerLegals,
  },
  mutations: {
    setAgentRecipientsLegals(state, data) {
      state.partnerLegals = data;
    },
  },
  actions: {
    fetchAgentRecipientsLegals({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax.post('/BussinessParties/api/partnerLegals'
        ).then(r => {
          commit('setAgentRecipientsLegals', r.data);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },
  },
}
